import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { MultiRowCarouselState_s, SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const WithinLease = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  let initialItems = _.sortBy(_.get(props.rowData[props.field], "items"), 'month');

  const emptyRecord = {
    inputtype: "withinLease",
    freerentdetail: {
      amtType: null,
      items: [],
      revenue: null,
      state: "withinLease"
    }
  }

  const emptyItem = {
    month: null,
    new: null,
    renewal: null
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem, i: 0}]);
  const [data, setData] = useState<object|null>({...props.rowData})

  function updateData(val:any, field:string):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    let nextItems = _.cloneDeep(items);
    nextItems = nextItems.map(item => {
      return {month: item.month, new: item.new, renewal: item.renewal}
    });

    _.set(nextData, "inputtype", "withinLease")
    _.set(nextData, "freerentdetail", {
      state: "withinLease"
    })
    _.set(nextData, "freerentdetail.amtType", _.get(localCache, "freerentdetail.amtType") || props.defaults['freeRentAmtType'])
    _.set(nextData, "freerentdetail.revenue", _.get(localCache, "freerentdetail.revenue") || props.defaults['freeRentRevenue'])
    _.set(nextData, "freerentdetail.items", nextItems)

    if(field === "freerentdetail.amtType") {
      _.set(localCache, "freerentdetail.amtType", val)
      _.set(nextData, "freerentdetail.amtType", val)
    } else if(field === "freerentdetail.revenue") {
      _.set(localCache, "freerentdetail.revenue", val)
      _.set(nextData, "freerentdetail.revenue", val)
    } else if(!_.isArray(field)) {
      nextData[field] = localCache[field] = val
    } else {
      if(nextItems[field[0]][field[1]] === val) return
      nextItems[field[0]][field[1]] = val
      _.set(localCache, "freerentdetail.items", nextItems)
      _.set(nextData, "freerentdetail.items", nextItems)
      setItems(nextItems.map((item, i) => { return {new: item.new, renewal: item.renewal, month: item.month, i}}));
    }
    setData(localCache)

    nextData["mosnew"] = null
    nextData["mosrenew"] = null
    nextData["amttype"] = null
    nextData["freerentrevtype"] = null

    props.persist(nextData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    let nextItems = items.map((item, i) => { return {...item}})

    _.set(nextData, "inputtype", "withinLease")
    _.set(nextData, "freerentdetail", {
      state: "withinLease"
    })
    _.set(nextData, "freerentdetail.amtType", _.get(localCache, "freerentdetail.amtType") || props.defaults['freeRentAmtType'])
    _.set(nextData, "freerentdetail.revenue", _.get(localCache, "freerentdetail.revenue") || props.defaults['freeRentRevenue'])

    setItems(nextItems)
    const strippedItems = nextItems.map(({i, ...rest}) => rest)
    _.set(nextData, "freerentdetail.items", strippedItems)

    props.persist(nextData, props.field, props.rowData)
  }

  const params = {
    data: items,
    persist: updateData
  }

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'withinLease') {
      setData(emptyRecord)
      setItems([{...emptyItem, i: 0}])
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('freerent', props.field)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('freerent', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s style={{marginBottom: 10}} className="carousel-single-row">
        <div>
          <label>Amt Type</label>
          <DropdownInput attrs={attrs} data={data} field="freerentdetail.amtType" default={props.defaults['freeRentAmtType']} options={['Mos']} disabled={true} />
        </div>
        <div>
          <label>Revenue</label>
          <DropdownInput className="automated" attrs={attrs} data={data} field="freerentdetail.revenue" default={props.defaults['freeRentRevenue']} options={['Rent', 'Rent + Recovery', 'All Revenues', 'Recovery']} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
      { items.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Month</label> }
              <NumberInput className="automated new-renewal" attrs={item_attrs} field={[`${row['i']}`, 'month']} {...params} />
            </div>
            <div>
              { i === 0 && <label>New</label> }
              <NumberInput className="automated new-renewal" attrs={item_attrs} field={[`${row['i']}`, 'new']} {...params} readPrecision={4} writePrecision={4} />
            </div>
            <div>
              { i === 0 && <label>Renewal</label> }
              <NumberInput className="automated new-renewal" attrs={item_attrs} field={[`${row['i']}`, 'renewal']} {...params} readPrecision={4} writePrecision={4} />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default WithinLease
